export default __webpack_public_path__ + "static/media/drew.d79f671a.png";